import axios from "axios";
import store from "../reduser/store";
import { logout } from "../reduser/userSlice";
import host from "../host";

const axiosInstance = axios.create({
  withCredentials: true,
});

let acctoken = null;

export const clearToken = () => {
  acctoken = null;
};

export const getToken = () => {
  return acctoken;
};

export const setToken = (token) => {
  acctoken = token;
};

const refreshAccessToken = async () => {
  try {
    const response = await axios.post(
      `${host}api/token/refresh/`,
      {},
      { withCredentials: true },
    );

    const { access } = response.data;
    setToken(access);
    return access;
  } catch (error) {
    store.dispatch(logout());
    return null;
  }
};

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const newAccessToken = await refreshAccessToken();
      if (newAccessToken) {
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest);
      }
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
